<template>
  <consultaV2 v-if="adobeTargetExperience === 'AR2024CNOMV2'" />
  <consulta v-else />
</template>

<script>
import Consulta from "@/views/Consulta";
import ConsultaV2 from "@/__tests-ab__/AR2024CNOMV2/views/Consulta";
export default {
  name: "ConsultaWrapper",
  components: {
    Consulta,
    ConsultaV2
  }
};
</script>
